import React from 'react';
import classNames from 'classnames';
import { ORIENTATION, SPACING } from '../../constants';

const StepLine = ({
  orientation = ORIENTATION.vertical,
  gap = SPACING.spacingM,
  withDecoration = true,
  children,
}) => {
  const stepLineClassNames = classNames(
    'ws-ui-step-line',
    `ws-ui-step-line--${orientation}`,
    `ws-ui-step-line--${gap}`,
    {
      'ws-ui-step-line--with-decoration': withDecoration,
    }
  );

  return <div className={stepLineClassNames}>{children}</div>;
};

export default StepLine;
